import callCmAPI from 'services/helpers/call-cm-api'

export const updateUser = ({ userId, data }) =>
  callCmAPI(`/user/${userId}`, {
    method: 'put',
    data,
  })
    .then((res) => res.data)
    .catch((err) => err)
